package pl.decks.personal.styles

import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.extendedByBase
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.css.vw

object GlobalStylesheet {
    val Screen = CssStyle.base {
        Modifier.width(100.vw).height(100.vh).overflow(Overflow.Hidden)
    }

    val Text = FontTypography.serif.extendedByBase {
        Modifier
            .fontSize(FontTypography.Size.Normal)
            .lineHeight(FontTypography.LineHeight.Normal)
            .fontWeight(FontTypography.Weight.Normal)
    }
}
